import User from "~/components/User/User"
import "./UserGroup.scss"
import type { User as UserType } from "~/types"

type UserGroupProps = {
  hideTitle?: boolean
  align?: "left" | "center" | "right"
  users: UserType[]
  guests: UserType[]
  size?: "xxs" | "medium"
}

function UserGroup({
  hideTitle = true,
  align = "center",
  users = [],
  guests = [],
  size = "medium",
}: UserGroupProps) {
  return (
    <div className="UserGroup">
      {hideTitle ? "" : <h4>Members</h4>}
      <div className={`UserGroup__pictures UserGroup__pictures--${align}`}>
        {users.map((user) => (
          <User
            key={user.id}
            name={user.name}
            picture={user.picture}
            className="UserGroup__picture"
            size={size}
          />
        ))}
        {users.length > 0 && guests.length > 0 && (
          <div className={`UserGroup__divider--${size}`} />
        )}
        {guests.map((user) => (
          <User
            key={user.id}
            name={user.name}
            isGuest
            className="UserGroup__picture"
            size={size}
          />
        ))}
      </div>
    </div>
  )
}

export default UserGroup
